import {createSelector} from 'reselect'
import {selectTaskManagement} from '../selectors'
import {getViewMode} from '../common/selectors'
import {getVisibleTaskIds as getKanbanTaskIds, isLoaded as isKanbanTasksLoaded} from '../kanban/selectors'
import {getLoadedTaskIds as getTableTaskIds, isLoaded as isTableTasksLoaded} from '../tasksTable/selectors'
import {TaskManagementViewMode} from '../constants'
import {arrayToSet} from '../../atUtils'

const getTaskSelection = (state) => selectTaskManagement(state).taskSelection

export const isExistingTaskIdsLoading = createSelector(
    getTaskSelection,
    (taskSelectionState) => taskSelectionState.existingTaskIdsLoading
)

export const isPendingSelectAll = createSelector(
    getTaskSelection,
    (taskSelectionState) => taskSelectionState.pendingSelectAll
)

export const isExistingTaskIdsLoaded = createSelector(
    getTaskSelection,
    (taskSelection) => taskSelection.existingTaskIdsLoaded
)

/**
 * Ids of selected tasks for perform operations.
 */
export const getSelectedTaskIds = createSelector(
    getTaskSelection,
    (taskSelectionState) => taskSelectionState.selectedTaskIds
)

const getExistingTaskIdsByFilters = createSelector(
    getTaskSelection,
    (taskSelectionState) => taskSelectionState.existingTaskIdsByFilters
)

export const getSelectedTaskIdsArray = createSelector(
    getSelectedTaskIds,
    (selectedTaskIds) => Object.keys(selectedTaskIds)
)

export const isNeedToLoadExistingTaskIds = createSelector(
    getSelectedTaskIdsArray,
    isPendingSelectAll,
    isExistingTaskIdsLoaded,
    isExistingTaskIdsLoading,
    (selectedTaskIds, pendingSelectAll, loaded, loading) => !loading && !loaded && (selectedTaskIds.length > 0 || pendingSelectAll)
)

export const isTasksLoaded = createSelector(
    getViewMode,
    isKanbanTasksLoaded,
    isTableTasksLoaded,
    (viewMode, kanbanTasksLoaded, tableTasksLoaded) => viewMode === TaskManagementViewMode.KANBAN ? kanbanTasksLoaded : tableTasksLoaded
)

/**
 * Ids of tasks that visible
 */
export const getVisibleTaskIds = createSelector(
    getViewMode,
    getKanbanTaskIds,
    getTableTaskIds,
    (viewMode, kanbanTaskIds, tableTaskIds) => {
        return arrayToSet(viewMode === TaskManagementViewMode.KANBAN ? kanbanTaskIds : tableTaskIds)
    }
)

/**
 * Visible and existing tasks for filters
 */
export const getExistingTaskIdsForView = createSelector(
    getExistingTaskIdsByFilters,
    getVisibleTaskIds,
    (existingIds, visibleIds) => ({
        ...existingIds, ...visibleIds,
    })
)

export const isAllTasksSelected = createSelector(
    getExistingTaskIdsForView,
    isExistingTaskIdsLoaded,
    getSelectedTaskIds,
    (existingTaskIds, existingTaskIdsLoaded, selectedTaskIds) => {
        return Object.keys(selectedTaskIds).length !== 0 && existingTaskIdsLoaded && Object.keys(existingTaskIds).every((id) => !!selectedTaskIds[id])
    }
)

export const isAllTasksSelectedCheckboxChecked = createSelector(
    isAllTasksSelected,
    isPendingSelectAll,
    (allTasksSelected, pendingSelectAll) => allTasksSelected || pendingSelectAll
)



// WEBPACK FOOTER //
// ./web/js/taskManagement/taskSelection/selectors.js